// Estado compartido de la UI de sincronizacion (Paso 8 / Fase 6).
// Controla la apertura del drawer de sync, que vive en +layout.svelte y se
// abre desde el badge flotante (PendingSyncBadge). Singleton: una sola instancia
// para toda la app.
let open = $state(false);

export const syncUi = {
    get open() {
        return open;
    },
    openDrawer() {
        open = true;
    },
    closeDrawer() {
        open = false;
    },
    toggle() {
        open = !open;
    },
};
